import React, { createRef, useRef, useState } from "react";
import { useSelector } from "react-redux";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond/dist/filepond.min.css";
import { FilePond } from "react-filepond";
import "../../assets/css/filePond.css";
import { InitalRender, originalValues } from "../../components/common/Helper";
import { getToken } from "../../utils/Auth";
import { API_BASE } from "../../utils/Constants";
import { getFormattedTime } from "../common/Helper";
import { TrimText } from "../common/TrimText";
import UserHover from "../common/UserHover";
import Swal from "sweetalert2";

export default function TicketComments(props) {
  const [isLoading, setIsLoading] = useState(false);
  const { ticketThread } = props;
  const { ticketData } = props; 
  const scroll_down_bottom = useRef();
  const btnAttachment = createRef();
  const filePondRef = createRef();
  const [files, setFiles] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [showFilePond, setShowFilePond] = useState(false);
  const [removeFile, setRemoveFile] = useState(null);
  const [currentimage, setcurrentimage] = useState('');
  const [fileIdMap, setFileIdMap] = useState({});
  const pendingUploadId = useRef(null);
  const [taggedUsers, setTaggedUsers] = useState([]);
  const [InptMessage, setInptMessage] = useState("");
  const [copyText, setCopyText] = useState(0);

  // Single source of truth - using ticketData.status only
  const isClosed = ticketData?.status === "Closed";

  const copyEmailText = (email) => {
    setCopyText(1);
    navigator.clipboard.writeText(email);
    setTimeout(() => {
      setCopyText(0)
    }, 1000);
  }

  const user = useSelector((state) => state.user);

  const handleInputChange = (e) => {
    if (!isClosed) {
      setInptMessage(e.target.value);
    }
  };

  const handleAttahment = () => {
    if (isClosed) return;
    if (btnAttachment.current) {
      btnAttachment.current.value = '';
    }
    btnAttachment.current.click();
  };

  const handleFiles = async (event) => {
    if (isClosed) return;
    const ufiles = await event.target.files;
    if (ufiles.length > 0) {
      if (ufiles[0]) {
        if (filePondRef.current) {
          try {
            await filePondRef.current.addFile(ufiles[0]);
          } catch (error) {
            console.log(error);
          }
        }
      }
    }
  };

  const handleFiles1 = async (event) => {
    if (isClosed) return;
    const ufiles = await event.clipboardData.files;
    if (ufiles.length > 0) {
      if (ufiles[0]) {
        if (filePondRef.current) {
          try {
            await filePondRef.current.addFile(ufiles[0]);
          } catch (error) {
            console.log(error);
          }
        }
      }
    }
  };

  const handleBtnMessage = async () => {
    if (isClosed) return;
    
    // Remove the @@uniqueId suffix before sending
    const cleanAttachments = attachments.map(att => att.split('@@')[0]);
    
    let messagePost = {
      message: InptMessage,
      files: cleanAttachments,
      taggedUsers,
      id_ticket: props.id_ticket,
    };

    setIsLoading(true);
    try {
      await props.parentHandleTicketThread(messagePost);
      setInptMessage("");
      setFiles([]);
      setAttachments([]);
      setFileIdMap({});
      setShowFilePond(false);
    } catch (error) {
      console.error("Failed to send message:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to send message. Please try again.",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };

  window.addEventListener("paste", async (e) => {
    if (isClosed) return;
    e.target.files = e.clipboardData.files;
    await handleFiles1(e);
    if (e.clipboardData && e.clipboardData.files && e.clipboardData.files.length > 0) {
      let oldFile = files
      if (oldFile.length < 3) {
        oldFile.push(e.clipboardData.files[0])
        setFiles(oldFile)
      }
    }
  });

  const handleUploadedFiles = (response) => {
    if (isClosed) return;
    // Use the pending upload ID that was set in onaddfile
    if (pendingUploadId.current) {
      const attachmentWithId = `${response}@@${pendingUploadId.current}`;
      setAttachments((attachments) => [...attachments, attachmentWithId]);
      pendingUploadId.current = null;
    } else {
      setAttachments((attachments) => [...attachments, response]);
    }
  };

  const handleDragEnter = event => {
    if (!isClosed) {
      setShowFilePond(true);
    }
  };

  return (
    <>
      <div className="comment-details col-md-9">
        <div className="comment-main ac-white-card p-0">
          <div className="card-header comments-card-header d-flex align-items-center">
            Comments
            {isClosed && (
              <span className="badge badge-secondary ml-2" style={{ backgroundColor: '#6c757d', color: 'white', padding: '3px 8px', borderRadius: '4px', fontSize: '12px' }}>
                <i className="fal fa-lock mr-1"></i>Closed
              </span>
            )}
          </div>
          <div className="card-body comments-card-body">
            <div className="comment-conversation-list-wrap">
              <ul className="comment-conversation-list list-unstyled">
                {ticketThread && ticketThread.length > 0 && (
                  ticketThread.map((thread, index) => {
                    return (
                      <React.Fragment key={index}>
                        {thread.id_sender > 0 ? (
                          <li
                            className="comment-user-current"
                            key={thread.id_sender}
                          >
                            <div className="comment-user-bx">
                              <div className="comment-user-img comment-box-pro assigned-title-blk">
                                <div className="comment-box-pro-item">
                                  {user?.photo ? <img src={user.photo} />: InitalRender(originalValues(user.first_name + " " + user.last_name, 23))}
                                </div>
                                  <span className="portal-status-icon online-u"></span>
                                <UserHover user={user} online="online" />
                              </div>
                              <div className="comment-user-detail">
                                {thread.attachments.length > 0
                                  ? thread.attachments.map((file, indKey) => {
                                    if (file.fileType == "download") {
                                      return (
                                        <div
                                          className="Attachment-area"
                                          key={indKey}
                                        >
                                          <i
                                            className="fa fa-paperclip"
                                            aria-hidden="true"
                                          ></i>{" "}
                                          Attached File :{" "}
                                          <a
                                            href={file.attachment}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {file.originalName}
                                          </a>
                                        </div>
                                      );
                                    } else {
                                      return (
                                        <div
                                          key={indKey}
                                          className="attached-media-comment Attachment-area"
                                        >
                                          <img className="curser" onClick={() => { setcurrentimage(file.attachment);}} src={file.attachment} alt="attachment" />
                                        </div>
                                      );
                                    }
                                  })
                                  : null}
                                {thread.message && thread.message !== "" ? (
                                  <div className="posted-comment">
                                    {thread.message}
                                  </div>
                                ) : null}
                                <small className="date">
                                  {getFormattedTime(thread.send_date)}
                                </small>
                              </div>

                            </div>
                          </li>
                        ) : (
                          <li
                            className="comment-user-other"
                            key={thread.id_sender}
                          >
                            <div className="comment-user-bx">
                              <div className="comment-user-img comment-box-pro assigned-title-blk">
                                <div className="comment-box-pro-item">
                                  {thread.picture_me ? <img src={thread.picture_me} onError={({ currentTarget }) => {
                                    currentTarget.onerror = null; // prevents looping
                                    currentTarget.closest('.comment-box-pro-item').append(InitalRender(TrimText(thread.userFullName, 23))); 
                                    currentTarget.remove();
                                  }} /> : InitalRender(TrimText(thread.userFullName, 23))}

                                </div>
                                   {thread?.assign_to_status == "Offline" ? <span className="portal-status-icon offline-u"></span> : <span className="portal-status-icon online-u"></span>}
                                <div className="assigned-title-info online_newpoints01">
                                  <article>
                                    <figure className="bgBlue">
                                      {thread.picture_me ? <img src={thread.picture_me} onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.closest('.bgBlue').append(InitalRender(TrimText(thread.userFullName, 23)));
                                        currentTarget.remove();
                                      }} /> : InitalRender(TrimText(thread.userFullName, 23))}
                                      {thread?.assign_to_status == "Offline" ? <span className="portal-status-icon offline-u"></span> : <span className="portal-status-icon online-u"></span>}
                                    </figure>
                                    <figcaption>
                                      <h4>{TrimText(thread.userFullName, 23)}</h4>
                                      <p>
                                        <i className="fal fa-envelope"></i>
                                        {thread.userEmail ? <><a className="hover-color-blue" onClick={() => copyEmailText(thread.userEmail)}>{thread.userEmail}</a>
                                          {copyText ? (
                                            <i className="fas fa-check-circle cat-greenhex"></i>
                                          ) : (
                                            thread.userEmail && <i
                                              className="fal fa-copy hover-color-blue"
                                              onClick={() => copyEmailText(thread.userEmail)}
                                            ></i>
                                          )}
                                        </> : ""}
                                      </p>
                                    </figcaption>
                                  </article>
                                </div>
                              </div>
                              <div className="comment-user-detail">
                                {thread.attachments.length > 0
                                  ? thread.attachments.map((file, ind) => {
                                    if (file.fileType == "download") {
                                      return (
                                        <div
                                          className="Attachment-area"
                                          key={ind}
                                        >
                                          <i
                                            className="fa fa-paperclip"
                                            aria-hidden="true"
                                          ></i>{" "}
                                          Attached File :{" "}
                                          <a href={file.attachment} rel="noopener noreferrer">
                                            {file.originalName}
                                          </a>
                                        </div>
                                      );
                                    } else {
                                      return (
                                        <div className="attached-media-comment Attachment-area" key={ind}>
                                          <img className="curser" onClick={() => { setcurrentimage(file.attachment); }} src={file.attachment} alt="attachment" />
                                        </div>
                                      );
                                    }
                                  })
                                  : null}
                                {thread.message && thread.message !== "" ? (
                                  <div className="posted-comment">
                                    {thread.read_at ? <>{thread.message}</> : <b>{thread.message}</b>}
                                  </div>
                                ) : null}
                                <small className="date">
                                  {getFormattedTime(thread.send_date)}
                                </small>
                              </div>
                            </div>
                          </li>
                        )}
                      </React.Fragment>
                    );
                  })
                )
                }
              </ul>
            </div>
          </div>
          {ticketData && ticketData.status &&
            <div className="card-footer comments-card-footer">
              {!isClosed ? (
                <>
                  <div className="comment-area-control">
                    <textarea
                      className="form-control comment-form-control"
                      placeholder="Start typing..."
                      onChange={handleInputChange}
                      value={InptMessage}
                      onDragEnter={handleDragEnter}
                      disabled={isClosed}
                    />
                  </div>

                  <div className="comment-area-actions">
                    <button
                      disabled={isClosed}
                      title="Add Attachment"
                      className="btn btn-submit-arrow no-shadow"
                      onClick={handleAttahment}
                    >
                      <i className="fal fa-paperclip"></i>
                    </button>
                    <div>
                      <input
                        disabled={isClosed}
                        type="file"
                        ref={btnAttachment}
                        style={{ display: "none" }}
                        onChange={(e) => handleFiles(e)}
                        showalerts={"false"}
                      />
                    </div>

                    {(!InptMessage && !files.length) || isLoading ? (
                      <button
                        title="Send Message"
                        className="btn btn-submit-arrow no-shadow"
                        onClick={handleBtnMessage}
                        disabled={true}
                      >
                        {isLoading ? (
                          <i className="fas fa-cog fa-spin"></i>
                        ) : (
                          <i className="fal fa-paper-plane"></i>
                        )}
                      </button>
                    ) : (
                      <button
                        title="Send Message"
                        className="btn btn-submit-arrow no-shadow"
                        onClick={handleBtnMessage}
                        disabled={isLoading}
                      >
                        <i className="fal fa-paper-plane"></i>
                      </button>
                    )}
                  </div>
                </>
              ) : (
                <div className="comment-area-control-full p-3 text-center text-muted">
                  <i className="fal fa-lock mr-2"></i>
                  This ticket is closed. No further comments can be added.
                </div>
              )}
            </div>
          }
          <div
            ref={scroll_down_bottom}
            className={!showFilePond || isClosed ? "hideFilePond" : "showFilePond"}
          >
            <FilePond
              name="post"
              allowMultiple={true}
              maxFiles={3}
              ref={filePondRef}
              files={files}
              onupdatefiles={setFiles}
              beforeRemoveFile={(f) => {
                if (isClosed) return false;
                const fileName = f?.file?.name;
                const uniqueId = f?.getMetadata?.('uniqueId') || fileIdMap[fileName];

                try {
                  if (uniqueId) {
                    // Remove from attachments array
                    setAttachments((prev) =>
                      prev.filter((att) => !att?.includes?.(`@@${uniqueId}`))
                    );

                    // Remove from fileIdMap
                    setFileIdMap((prev) => {
                      const newMap = { ...prev };
                      delete newMap[fileName];
                      return newMap;
                    });

                    // Extracting original filename from attachment for removal API
                    const attachmentToRemove = attachments?.find?.((att) =>
                      att?.includes?.(`@@${uniqueId}`)
                    );

                    if (attachmentToRemove) {
                      const originalPath = attachmentToRemove?.split?.('@@')[0];
                      const fileNameFromPath = originalPath?.split?.('/')?.pop?.();
                      setRemoveFile(fileNameFromPath);
                    } else {
                      console.error('No matching attachment found — skipped removal');
                      return false;
                    }
                  } else {
                    console.error('File has no name or unique ID — skipped removal');
                    return false;
                  }
                  return true; 
                } catch (error) {
                  console.error('Error in beforeRemoveFile:', error);
                  return false;
                }
              }}
              onaddfile={(err, fileItem) => {
                if (isClosed) return;
                setShowFilePond(true);
                if (!err) {
                  const uniqueId = crypto.randomUUID();
                  const fileName = fileItem.file.name;

                  // Store the unique ID in the file's metadata
                  fileItem.setMetadata('uniqueId', uniqueId);

                  // Update fileIdMap
                  setFileIdMap((prev) => ({ ...prev, [fileName]: uniqueId }));
                  
                  // Store for use in onload
                  pendingUploadId.current = uniqueId;
                }
              }}
              disabled={isClosed}
              server={{
                url: API_BASE,
                process: {
                  url: "/addTicketAttachments",
                  headers: {
                    Authorization: `Bearer ${getToken()}`,
                  },
                  ondata: (formData) => {
                    if (isClosed) return false;
                    setIsLoading(true);
                    return formData;
                  },
                  onload: (response) => {
                    handleUploadedFiles(response);
                    setIsLoading(false);
                  },
                },
                revert: {
                  url: `/removeTicketAttachments/${removeFile}`,
                  headers: {
                    Authorization: `Bearer ${getToken()}`,
                  },
                  onload: (response) => {
                    setRemoveFile(null);
                  },
                },
              }}
            />
          </div>
        </div>
      </div>
      <div onClick={() => { setcurrentimage('') }} className={`image-popup-block ${currentimage != '' ? 'active' : ''}`}>
        <div className="image-popup flexible-modal">
          <button type="button" onClick={() => { setcurrentimage('') }} className="close-icon"><i className="fas fa-times"></i></button>
          <div className="image-popup-img">
            <img src={currentimage} alt="preview" />
          </div>
        </div>
      </div>
    </>
  );
}